import React from 'react';
import { TChildren } from '../../typings/common';
import styles from './Toolbar.module.scss';

interface Props {
  children: TChildren;
}

const Toolbar: React.FC<Props> = ({ children }) => (
  <section className={styles.toolbar}>{children}</section>
);

export default Toolbar;
